import * as React from "react";
const SvgPause = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 26 26", xmlns: "http://www.w3.org/2000/svg", style: {
  width: "100%",
  height: "100%",
  color: "#ffffff"
}, ...props }, /* @__PURE__ */ React.createElement("title", null, "\u041F\u0430\u0443\u0437\u0430"), /* @__PURE__ */ React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("rect", { x: 5, y: 3, width: 5, height: 20, rx: 1 }), /* @__PURE__ */ React.createElement("rect", { x: 16, y: 3, width: 5, height: 20, rx: 1 })));
export default SvgPause;
